module.exports = {"id":"221310","name":"Andrés Felipe Roa","rating":"73","photo":"./data/images/photos/2/221310.png","club":{"name":"Deportivo Cali","logo":"./data/images/clubs/DeportivoCali.png"},"positions":["MOC","MG"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AndresFelipeRoa0.json
// module id = 389
// module chunks = 0